module.exports = __webpack_public_path__ + "static/img/2.f927fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/soft/2.jpg
// module id = Nqcz
// module chunks = 13